Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.ExportableOptionsView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/exportable_options']

  events:
    'click .export-png': 'onClickPNG'
    'click .export-csv': 'onClickCSV'
    'click .export-xlsx': 'onClickXLSX'

  render: =>
    @$el.html @template
    @

  onClickPNG: =>
    @trigger('chart:exportPNG')

  onClickCSV: =>
    @trigger('chart:exportCSV')

  onClickXLSX: =>
    @trigger('chart:exportXLSX')
